export const allowedPosition = {
    QB: "QB",
    OL: "OL",
    WR: "WR",
    TE: "TE",
    RB: "RB",
    OS: "OL",
    DL: "DL",
    LB: "LB",
    S: "S",
    C: "C",
    DB: "C",
    DF: "DL",
    IB: "LB",
    OB: "LB",
    K: "K",
    ST: "ST",
  };